import { Component, OnInit ,Renderer2 ,Inject ,HostListener} from '@angular/core';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../services/index';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers:[AuthService]
})
export class NavbarComponent implements OnInit {
 
  scrWidth: number;
  closeResult = '';
  btndis=true;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  objpayop:any={};

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
       
        this.scrWidth = window.innerWidth;
        console.log(this.scrWidth);
        if(this.scrWidth<1000){
          this.toggel();
        }
        else{
          this.toggelin();
        }
  }

  clnm:string='';
  username:string='';
  aynm="";
 
  constructor(private Auth: AuthService,private router: Router, @Inject(DOCUMENT) private document: Document,
  private renderer: Renderer2,private modalService: NgbModal) { 
 
   
  }


  openpayop(content) {
    // if(cmd=='insert')
    // {
    //   this.objpayop={};
     
      
    //   this.objpayop.payoptid=0;
     
    //   this.objpayop.oprtag='insert';
     
  
    // }
  
    // else if(cmd=='update')
    // {
    //   this.objpayop=objdata;
    //   this.objpayop.oprtag='update';
    // }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  ngOnInit(): void {
    this.clnm=localStorage.getItem('clnm');
    this.aynm=localStorage.getItem('aynm');
    this.username=localStorage.getItem('usrname');
    console.log("width",innerWidth);

   
    
  }
  clicklogout()
  {
    this.Auth.logout();
    this.router.navigate(['login']);

  }


  toggel(){
    this.renderer.addClass(this.document.body, 'ls-closed');
    this.document.getElementById("show").style.display="none";
    this.document.getElementById("close").style.display="block";
    
  }
  toggelin(){
    this.renderer.removeClass(this.document.body, 'ls-closed');
    // this.renderer.addClass(this.document.body, 'overlay-open');
    this.document.getElementById("show").style.display="block";
    this.document.getElementById("close").style.display="none";
    

  }
  onclicklogo()
  {
    this.router.navigate(['/app/home']);
  }


  checkmatch(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    // console.log('Input field lost focus. Value:', inputValue);
    // Add your custom logic here, e.g., validation, data processing
    if (inputValue !== this.objpayop.newpass )
    {
      this.btndis=true;
      alert("Password Not matching");
    }
    else 
    {
      this.btndis=false;
    }
  }


  changepass() {
    
    // console.log('save-model', this.objpayop);
    // var dbnm='';
    
  
    this.Auth.changepass(this.objpayop)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            this.objpayop={};
            if(resultArray.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.clicklogout();
             // this.Getsel_sp_massubgp();
            //  this.Bindtable();
            }
            
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();
  
  }
  
}
